// extracted by mini-css-extract-plugin
export default {"list-report-content__container":"styles_list-report-content__container__Su59Z"};